import { render, staticRenderFns } from "./CreatePasswordForm.vue?vue&type=template&id=0a3a7f8a&"
import script from "./CreatePasswordForm.vue?vue&type=script&lang=js&"
export * from "./CreatePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports